<template>
    <div>
        <div class="tile is-ancestor">
            <div class="tile has-text-left is-12 is-vertical is-parent">
                <div class="tile is-child box">
                    <div class="columns is-mobile">
                        <div class="column is-one-third"><strong>Name:</strong></div>
                        <div class="column ">{{currentMethod.name}}</div>                        
                    </div>
                    <div class="columns is-mobile">
                        <div class="column is-one-third"><strong>Status:</strong></div>
                        <div class="column">{{currentMethod.status}}</div>                        
                    </div>
                    <div class="columns is-mobile">
                        <div class="column is-one-third"><strong>Concentration unit:</strong></div>
                        <div class="column">{{currentMethod.concentration_unit}}</div>  
                    </div>  
                    <div class="columns is-mobile">
                        <div class="column is-one-third"><strong>Area unit:</strong></div>
                        <div class="column">{{currentMethod.area_unit}}</div>  
                    </div>   
                    <div class="columns is-mobile">
                        <div class="column is-one-third"><strong>Retention time unit:</strong></div>
                        <div class="column">{{currentMethod.retention_time_unit}}</div>  
                    </div>    
                    <div class="columns is-mobile">
                        <div class="column  is-one-third"><strong>Created on:</strong></div>
                        <div class="column">{{moment(currentMethod.created_at).format("DD MMMM YYYY")}}</div>  
                    </div>                    
                </div>
                <div class="tile is-child">
                    <b-collapse class="card" aria-id="contentIdForA11y3">
                        <div
                            slot="trigger" 
                            class="card-header"
                            role="button"
                            aria-controls="contentIdForA11y3">
                            <p class="card-header-title">
                                Description
                            </p>
                            <a class="card-header-icon">
                                <span class="icon is-small is-pulled-right">
                                    <i class="fas fa-caret-down"></i>
                                </span>
                            </a>
                        </div>
                        <div class="card-content">
                            <div class="content">
                                {{currentMethod.method_description}}
                            </div>
                        </div>
                    </b-collapse>
                </div>
                <div class="tile is-child box">
                    <p class="subtitle is-4">Associated Analytes</p>                    
                    <b-table
                        :data="isEmpty ? [] : currentMethod.analytes"
                        :striped=true
                        :hoverable=true
                        :loading="isLoading"
                        :mobile-cards=true>

                        <template slot-scope="props"> 
                            <b-table-column field="short_name" label="Short Name">
                                {{ props.row.short_name }}
                            </b-table-column>
                            
                            <b-table-column field="official_name" label="Official Name">
                                {{ props.row.official_name }}
                            </b-table-column>

                            <b-table-column field="abbrevation" label="Abbrevation" centered>
                                {{ props.row.abbreviation }}
                            </b-table-column>

                            <b-table-column field="target_concentration" label="Target Concentration" centered>
                                {{ props.row.target_concentration }}
                            </b-table-column>
                        </template>

                        <template slot="empty">                            
                            <b-table
                                :loading="false"
                                :focusable="true"
                                :mobile-cards="true">
                                    <p>No Associated Analytes...</p>
                                    <p>Edit the Analytical Method to add some</p>
                            </b-table>
                        </template>
                    </b-table>
                </div>
                
                <div class="tile is-child box">
                    <p class="subtitle is-4">Files</p>
                    
                    <a class="button is-medium" v-bind:href="currentMethod.method_file" download>
                        <span class="icon is-medium">
                            <i class="fas fa-download"></i>
                        </span>
                        <span>Download the chromatograph method file</span>
                    </a>
                    <span style="margin-left:20px"></span>
                    <a class="button is-medium" v-bind:href="currentMethod.method_description_file" download>
                        <span class="icon is-medium">
                            <i class="fas fa-download"></i>
                        </span>
                        <span>Download a method description file</span>
                    </a>
                    
                </div>         
            </div>
        </div>
    </div>
</template>


<script>
var moment = require('moment');
export default {
    name: "ViewMethodFeature",
    props: ["currentMethod"],

    data: function() {
        return {
            moment:moment,
            isEmpty: false,
            isLoading: false,
            isOpenActive: true,
            isOpenArchived: false
        }
    },
    methods : {
        editMethod: function (currentMethod) {
            console.log("edit btn in view clicked for: ", currentMethod.name)
            this.$emit("editMethod", currentMethod);
        },
        back: function() {
            this.$emit("back");
        },
        downloadMethodFile: function(currentMethod){
            // console.log("currentMethod.method_file", currentMethod.method_file)
            this.$emit("downloadMethodFile", currentMethod.method_file)            
        },
        accordionAction: function(id) {
            var accordionButton = document.getElementById(id)
            var contentOfAccordion = document.getElementById(id).nextSibling
            // console.log("x.style.display", x) is-primary 
            if (contentOfAccordion.style.display == "block") {
                contentOfAccordion.style.display = "none"
                accordionButton.classList.remove("is-primary");
            } else if (contentOfAccordion.style.display == "none") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            } else if(contentOfAccordion.style.display == "") {
                contentOfAccordion.style.display = "block"
                accordionButton.classList.add("is-primary");
            }

            // accordionButton class
            var otherAccordions = Array.from(document.getElementsByClassName("accordionButton"))
            console.log("ohters...", otherAccordions)    
            otherAccordions.forEach(function(otherAccordionButton){
                if(accordionButton != otherAccordionButton){
                    var content = otherAccordionButton.nextSibling
                    content.style.display = "none"
                    otherAccordionButton.classList.remove("is-primary");
                }
                
            })

        }  
    }
}
</script>

<style scoped>
.contentOfAccordion{
    display: none;
}
</style>